//toda vez que precisamos alterar uma informação passamos pelo reducer
//primeira coisa que criamos é uma interface para tipar os dados que teremos na store
//criar interface dentro do reducer

import { createReducer, on } from '@ngrx/store';
import { IContabilidade } from 'src/app/shared/interfaces/contabilidade/icontabilidade';
import {
  loadContabilidade,
  loadContabilidadeSuccess,
  saveContabilidadeSuccess,
} from './contabilidade.actions';

export interface IContabilidadeState {
  lista: IContabilidade[];
  isLoading: boolean;
}

const initialState: IContabilidadeState = {
  lista: [
  ],
  isLoading: false
};

export const contabilidadeReducer = createReducer(
  initialState,
  //loading
  on(loadContabilidade, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(loadContabilidadeSuccess, (state, { lista }) => ({
    ...state,
    lista: [...lista],
    isLoading: false,
  })),

  on(saveContabilidadeSuccess, (state, { contabilidade }) => ({
    ...state,
    lista: [...state.lista, contabilidade],
  }))
);
//colocar como parametro o contabilidadeReducer lá no app.module
//agora criamos o selector em um novo arquivo
